import UserIcon from "../../../assets/images/profile.svg";
import LoginAndSecurity from "../../../assets/images/shield-security.svg";
// import Transaction from "../../../assets/images/convert-card.svg";
import OrderHistory from "../../../assets/images/keyboard.svg";
import ShareRewards from "../../../assets/images/coin.svg";
import Logout from "../../../assets/images/logout.svg";
import Share from "../../../assets/images/share.png";
import NotificationIcon from "../../../assets/images/notifications.png";

export const tabsItem = [
  {
    name: "Personal Information",
    icon: UserIcon,
  },
  {
    name: "Login and Security",
    icon: LoginAndSecurity,
  },
  {
    name: "Notifications",
    icon: NotificationIcon,
  },
  {
    name: "Order History",
    icon: OrderHistory,
  },
  {
    name: "Share Rewards",
    icon: ShareRewards,
  },
  {
    name: "Share History",
    icon: Share,
  },
  {
    name: "Logout",
    icon: Logout,
  },
];
